import React from 'react';
import PropTypes from 'prop-types';
import FormTextContainer from '../../../redux/containers/FormTextContainer';
import DayMonthYear from '../DayMonthYear/DayMonthYear';
import CreditAssessmentErrorMessage from '../CreditAssessmentErrorMessage/CreditAssessmentErrorMessage';

const NameOnID = props =>
  <section>
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h3 className="half-charcoal">Name as shown on your ID</h3>
        </div>
      </div>
      <CreditAssessmentErrorMessage caError={props.caError} />
      <div className="row">
        <div className="col-sm-6">
          <FormTextContainer
            name="creditAssessment.firstName"
            label="Given name"
            placeholder="Given name"
            autotestClass="autotest-ca-first-name"
            maxLength={40}
            required
          />
        </div>
        <div className="col-sm-6">
          <FormTextContainer
            name="creditAssessment.middleName"
            label="Middle name"
            placeholder="Middle name"
            autotestClass="autotest-ca-middle-name"
            maxLength={40}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <FormTextContainer
            name="creditAssessment.lastName"
            label="Surname"
            placeholder="Surname"
            autotestClass="autotest-ca-last-name"
            maxLength={40}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <DayMonthYear
            name="creditAssessment.dateOfBirth"
            label="Date of Birth"
            autotestClass="autotest-ca-date-of-birth"
            required
          />
        </div>
      </div>
    </div>
  </section>
;

NameOnID.propTypes = {
  caError: PropTypes.object
};

export default NameOnID;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/NameOnID/NameOnID.js
 **/